module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fronttitle"
  }, [_c('a', {
    attrs: {
      "id": "p_3"
    }
  }), _vm._v(" Gronk Lineup")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center",
      "text-indent": "0",
      "width": "NaN%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk_1",
      "src": "images/GrowingUpGronk_1.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "text-align": "center",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk_2",
      "src": "images/GrowingUpGronk_2.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "text-align": "center",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk_3",
      "src": "images/GrowingUpGronk_3.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "text-align": "center",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk_4",
      "src": "images/GrowingUpGronk_4.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "text-align": "center",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk_5",
      "src": "images/GrowingUpGronk_5.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "text-align": "center",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk_6",
      "src": "images/GrowingUpGronk_6.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center",
      "text-indent": "0",
      "width": "75%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk-10",
      "src": "images/GrowingUpGronk-10.jpg"
    }
  })])]), _c('br'), _c('span', {
    staticClass: "subcaption"
  }, [_vm._v("Proudly sporting Patriots caps at Rob’s draft day in 2010. From left, Gordie, Chris, Rob, Goose, and Dan.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-right": "auto",
      "margin-left": "auto",
      "width": "99%",
      "page-break-before": "auto",
      "page-break-inside": "avoid",
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center",
      "text-indent": "0",
      "width": "75%"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "text-indent": "0",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "art",
    staticStyle: {
      "width": "99%"
    },
    attrs: {
      "alt": "[Image]",
      "id": "GrowingUpGronk-11",
      "src": "images/GrowingUpGronk-11.jpg"
    }
  })])]), _c('br'), _c('span', {
    staticClass: "subcaption"
  }, [_vm._v("Rob, Dan, Goose, Gordie, and Chris, 1994.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134c44ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 66
// module chunks = 0